<!-- src/components/BaseLayout.vue -->
<template>
  <div class="app-shell">
    <!-- Header (full width) -->
    <SiteHeader />

    <!-- White title strip -->
    <div v-if="title || subtitle" class="titlebar">
      <div class="container">
        <h1 v-if="title" class="title">{{ title }}</h1>
        <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <!-- Main content centered on SAME header-colored background -->
    <main :class="narrow ? 'container-narrow content' : 'container content'" role="main">
      <slot />
    </main>

    <!-- Footer (renders atop the same page bg color) -->
    <SiteFooter />
  </div>
</template>

<script setup>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  /** When true, content uses a narrower max-width (48rem). Great for forms/cards. */
  narrow: { type: Boolean, default: false },
})

import { provide, computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'

function normalizePlan(raw) {
  if (raw == null) return 'free'
  if (typeof raw === 'string') return raw.trim().toLowerCase()
  const v = raw.plan ?? raw.tier ?? raw.name ?? raw.level ?? raw.value
  return String(v ?? 'free').trim().toLowerCase()
}

const auth = typeof useAuthStore === 'function' ? useAuthStore() : null
const { user, profile, subscription, ready } = auth ? storeToRefs(auth) : {}

onMounted(() => {
  if (auth && typeof auth.init === 'function' && !ready?.value) auth.init()
})

const currentPlan = computed(() => {
  const raw =
    auth?.currentUser?.plan ??
    auth?.currentUser?.subscription?.tier ??
    auth?.plan ??
    auth?.subscription?.tier ??
    user?.value?.plan ??
    user?.value?.subscription?.tier ??
    profile?.value?.plan ??
    profile?.value?.subscription?.tier ??
    subscription?.value?.tier ??
    'free'
  return normalizePlan(raw)
})

provide('currentPlan', currentPlan)
provide('plan', currentPlan)
provide('subscriptionTier', currentPlan)
</script>
